export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.6.3';
//# sourceMappingURL=version.js.map